/* tslint:disable */
/* eslint-disable */
/**
 * WeighMed Backend APIs - OpenAPI 3.0
 * You can find out more about Swagger at [https://editor.swagger.io/](https://editor.swagger.io/).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VLoginRequestParams
 */
export interface VLoginRequestParams {
    /**
     * Email
     * @type {string}
     * @memberof VLoginRequestParams
     */
    username: string;
    /**
     * Password
     * @type {string}
     * @memberof VLoginRequestParams
     */
    password: string;
}

/**
 * Check if a given object implements the VLoginRequestParams interface.
 */
export function instanceOfVLoginRequestParams(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function VLoginRequestParamsFromJSON(json: any): VLoginRequestParams {
    return VLoginRequestParamsFromJSONTyped(json, false);
}

export function VLoginRequestParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VLoginRequestParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
    };
}

export function VLoginRequestParamsToJSON(value?: VLoginRequestParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
    };
}

